<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box">
			<div class="router-title-item">
				<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
				<div class="router-title-tit">
					<span style="position: absolute;">&gt;&ensp;历史数据&ensp;&gt;&ensp;人员历史记录</span>
					<el-tabs class="whole-page-tabs" v-model="activeName" @tab-click="handleClick" tab-position="top">
						<el-tab-pane label="历史轨迹" name="first" clor="red"></el-tab-pane>
						<el-tab-pane label="绑定记录" name="second"></el-tab-pane>
					</el-tabs>
				</div>
				<div v-if="false" class="router-title-tit">人员绑定记录</div>
			</div>
		</div>
		<!-- router-title-box end -->
		
		<!-- 组件 历史轨迹 -->
		<OutdoorTrackTable v-show="activeName == 'first'" ref="OutdoorTrackTable" :pBindingType="1" />
		<!-- 组件 绑定记录 -->
		<UserBindingTable v-show="activeName == 'second'" ref="userBindingTable" />

	</div>
</template>

<script>
	// 组件 绑定记录
	import UserBindingTable from '@/components_pages/Record/UserBindingTable'
	// 组件 历史轨迹
	import OutdoorTrackTable from '@/components_outdoor/Outdoor/OutdoorTrackTable'

	export default {
		/*
		 * 组件名
		 */
		name: "UserRecord",
		/**
		 * 引用组件
		 * */
		components: {
			// 组件 绑定记录
			UserBindingTable,
			// 组件 历史轨迹
			OutdoorTrackTable,
		},
		data() {
			return {
				activeName: '',
				userRecordFlag: false,
				carRecordFlag: false
			}
		},
		created() {
			
		},
		mounted() {
			this.activeName = 'first';
			//请求1
			this.$refs.userBindingTable.researchRecord();
		},
		methods: {
			/**
			 * @Des 关闭路由
			 * @Auth
			 * @Date
			 */
			closeRouter() {
				// 跳转到 首页
				this.$router.replace({
					path: this.$store.state.homePage
				}, () => {}, () => {});
			}, // closeRouter
			/**
			 * @Des tab 切换
			 * @Auth
			 * @Date
			 */
			handleClick(tab, event) {
				if(tab.index == 0) {
					//请求1
					
				} else if(tab.index == 1) {
					//请求2
					this.$refs.userBindingTable.researchRecord();
				}
			},// handleClick
		},// methods
	}
	// API 资源信息
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/system-manager/record/UserRecord.vue